import { Fragment, h } from 'preact';
import { useModal } from '../../modal-context';
import ThreekitIcons from '../threekit-icons';
import Image from '../../../utils/image';
import { useThreekit } from '../../threekit-context';
import closeCustomizer from '../util/closeCustomizer';

function ExitModal() {
  const { closeModal, modalName } = useModal();
  const { template } = useThreekit();

  if (modalName !== 'Exit') {
    return null;
  }

  const handleClick = async () => {
    if (template === 'product.customizer') {
      window.location.href = '/';
      return;
    }

    closeModal();
    closeCustomizer();
  };

  return (
    <>
      <div
        onClick={() => closeModal()}
        className="fixed top-0 left-0 z-10 w-full h-full bg-black cursor-pointer bg-opacity-40"
      />
      <div className="top-0 right-0 h-[100dvh] flex flex-col fixed w-[304px] laptop:w-[375px] bg-white z-20">
        <header className="py-[23px] px-5 flex justify-between border-b border-b-grey-300">
          <p className="heading-5">ARE YOU SURE?</p>
          <button
            type="button"
            className="cursor-pointer"
            onClick={() => closeModal()}
          >
            <ThreekitIcons type="exitIcon" />
          </button>
        </header>

        <main className="flex flex-col justify-center flex-1 overflow-y-auto text-center px-[15px]">
          <p className="heading-5 max-w-[300px] mx-auto">
            Are You SURE you want to exit?
          </p>
          <Image
            className="max-w-[360px] w-full object-center object-contain mx-auto mt-10"
            src={
              'https://cdn.shopify.com/s/files/1/0662/2134/2979/files/royal_blue.png?v=1679047453'
            }
          />
          <p className="mt-8 font-m-16 max-w-[320px] mx-auto">
            Exiting the customizer now will mean your customizations will be
            erased.
          </p>
        </main>

        <footer className="py-[18px] px-5 bg-bg-6 text-white border-top border-grey-400">
          <button className="w-full btn-secondary" onClick={() => closeModal()}>
            Cancel
          </button>
          <a
            onClick={handleClick}
            className="w-full mt-2 text-center text-black border-none cursor-pointer btn"
          >
            Exit ANYWAY
          </a>
        </footer>
      </div>
    </>
  );
}

export default ExitModal;
